@import "styles/variables";

.index {
  width: 100%;
  max-width: 1000px;
  display: flex;
  margin: 0 auto 1em;
}

.column {
  width: 50%;
  background-color: var(--color-white);
  border-radius: var(--background-border-radius);
  margin: 1% 1% 1% .5%;
}

@media (max-width: 900px) {
  .index {
    flex-direction: column;
  }
  .column {
    width: calc(100% - 1%);
  }
}

.column-padding {
  padding: 20px;
}

.form {
  position: relative;
}

.bookings {
  overflow-y: scroll;
  max-height: 0;
}

.location-name {
  margin-left: -18px;
  margin-top: -45px;
  position: absolute;
  color: var(--color-white);
  vertical-align: bottom;
}
.location-name-clickable {
  cursor: pointer;
}
.location-name-clickable:hover .location-text {
  text-decoration: underline;
}
.location-icon {
  display: inline-block;
  color: white;
  font-size: 17px;
  height: 100%;
  width: 18px;
}
.location-text {
  display: inline-block;
}

.input-container {
  width: 100%;
}
.attribute-container {
  width: 60%;
}

.col4 {
  width: 100%;
}

.searchfield:nth-of-type(2) {
  margin-top: 20px;
}

.dateTimeRow {
  display: flex;
  margin-top: 20px;
  align-items: flex-end;
}

.passengerField {
  margin-top: 20px;
  flex-grow: 1;
}

.passengerExtras {
  display: flex;
  gap: 15px;
}

.passengerExtras > div {
  width: 50%;
}

.disabled {
  opacity: .3;
  pointer-events: none;
}
.smsCheckbox {
  display: flex;
  height: 36px;
  align-self: end;
  align-items: center;
}
.smsCheckbox label {
  flex: 1 auto;
  display: flex;
  align-items: center;
  color: var(--color-black);
  margin-left: 9px;
}
